import { $tourData, $tourDataApi } from '@stores/dataStores';
import { useStoreMap } from 'effector-react';
import GlobalBase from './GlobalBase';

function PanelGlobal() {
  const flag = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.flag,
  });
  const firstSceneButton = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.config?.firstSceneButton ?? {},
  });
  const customIcons = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.config?.customIcons ?? {},
  });
  const canvasBgColor = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.config?.ui?.canvasBgColor || '#000000',
  });
  const author = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.config?.author ?? {},
  });

  return (
    <GlobalBase
      defaultValue={{
        flag,
        firstSceneButton,
        customIcons,
        canvasBgColor,
        author,
      }}
      onConfirm={(val) => {
        $tourDataApi.update((draft) => {
          if (val.flag) {
            draft.flag = val.flag;
          }
          if (val.firstSceneButton) {
            draft.config = {
              ...draft.config,
              firstSceneButton: val.firstSceneButton,
            };
          }
          if (val.customIcons) {
            draft.config = {
              ...draft.config,
              customIcons: val.customIcons,
            };
          }
          if (val.canvasBgColor) {
            draft.config.ui ??= {};
            draft.config.ui.canvasBgColor = val.canvasBgColor;
          }
          if (val.author) {
            draft.config = {
              ...draft.config,
              author: val.author,
            };
          }
        });
      }}
    />
  );
}

export default PanelGlobal;
